// extracted by mini-css-extract-plugin
export default {"addField":"PriceListSettings_addField__D3TrR"};